var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51106 5.47195e-06C11.8328 5.47195e-06 14.1546 0.00276991 16.4764 5.47195e-06C17.9441 -0.00275897 18.9972 1.0422 18.9972 2.51565C18.9972 7.03551 18.9945 11.5554 18.9972 16.0752C18.9972 16.4899 19.0138 16.9018 18.8811 17.3054C18.5605 18.2923 17.6898 18.9558 16.6533 18.9945C16.5981 18.9972 16.5428 18.9972 16.4875 18.9972C11.8218 18.9972 7.15886 19 2.49316 19C1.06968 19 0 17.9385 0 16.5341C0 11.8899 0.00276404 7.2456 0 2.60134C0 1.81071 0.226651 1.1196 0.843032 0.588831C1.29633 0.20181 1.82427 0.00276991 2.4213 0.00276991C4.78455 5.47192e-06 7.1478 5.47195e-06 9.51106 5.47195e-06ZM11.5868 6.22553C11.5012 6.31675 11.4542 6.36651 11.4072 6.41627C9.38944 8.43431 7.37169 10.4524 5.35394 12.4732C5.16322 12.6639 4.96421 12.8491 4.78731 13.0509C4.3506 13.5513 4.59107 14.2618 5.23785 14.4055C5.58059 14.4829 5.83765 14.3419 6.07259 14.1069C8.24236 11.9369 10.4121 9.76677 12.5847 7.59669C12.6399 7.5414 12.6952 7.49164 12.7809 7.41147C12.7809 8.30438 12.7754 9.14754 12.7837 9.99069C12.7864 10.4468 13.1651 10.8283 13.5935 10.8228C14.0634 10.8173 14.4393 10.4496 14.4393 9.97964C14.4421 8.47301 14.4421 6.9664 14.4393 5.45978C14.4366 4.91242 14.0855 4.57239 13.5383 4.56686C13.1237 4.5641 12.709 4.56686 12.2944 4.56686C11.2026 4.56686 10.1109 4.5641 9.01906 4.56963C8.56023 4.57239 8.17879 4.94835 8.18155 5.37408C8.18432 5.8468 8.54364 6.21447 9.01906 6.22553C9.30099 6.23105 9.58568 6.22829 9.87038 6.22829C10.4204 6.22829 10.976 6.22553 11.5868 6.22553Z",
    fill: "#EEAD20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.c66bfdd80c37c699c7e9dc3754a98aa0.svg";
export { ForwardRef as ReactComponent };